// Frontend version / build identifier. Update this when you deploy a new version
// so you can verify the browser is running the latest build.
const APP_VERSION = "1.9.11-rtsp-only-existing-mark";

export default APP_VERSION;
